import React from "react";
import { Field, FieldProps } from "formik";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import SelectionGroup from "components/common/selection/selectionGroup";

interface UserTypeSelectorProps {
  name: string;
  enabledUserTypes: WintSuperkollAPIModel.UserTypeDto[];
}

const UserTypeSelector: React.FC<UserTypeSelectorProps> = ({ name, enabledUserTypes }) => {
  const userTypeItems: SelectionItem[] = enabledUserTypes.map((type) => ({
    id: type.id,
    value: type.name ?? "",
  }));

  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const selectedItem = userTypeItems.find((item) => item.id === field.value);

        return (
          <SelectionGroup
            items={userTypeItems}
            value={selectedItem ? [selectedItem] : []}
            onChange={(items) => {
              form.setFieldValue(name, items.length > 0 ? items[0].id : undefined);
            }}
            hideViewAll
          />
        );
      }}
    </Field>
  );
};

export default UserTypeSelector;
